import { useDispatch } from 'react-redux';
import useRouter from '../../../../hooks/useRouter';
import { closeModal, openModal } from '../../../Modal/modalReducer';
import * as actions from '../../../../store/actions';
import Box from '@mui/material/Box';
import { Button } from '@mui/material';
import React from 'react';
import makeStyles from '@mui/styles/makeStyles';

const useStyles = makeStyles((theme) => ({
  remove: {
    fontFamily: theme.fonts.base,
    color: theme.palette.common.white,
    background: theme.palette.success.main,
    margin: 0
  },
  fix: {
    fontFamily: theme.fonts.base,
    background: theme.palette.warning.main,
    color: theme.palette.common.white,
    margin: 0,
    minWidth: 100
  }
}));


const TableAlertAction = ({ entityId, url, type }) => {
  console.log(entityId, url, type);
  const dispatch = useDispatch();
  const router = useRouter();
  const classes = useStyles();

  const navigateAlert = () => {
    dispatch(actions.toggleAlertMenu())
    router.push(url);
  };

  const handleMarkDone = () => {
    dispatch(
      openModal({
        modalType: 'AlertModal',
        modalProps: {
          title: 'Remove Alert',
          content:
            'Are you sure you want to remove the selected Alert? This action cannot be undone!',
          handleConfirm: () => {
            dispatch(actions.hideAlert(entityId, type));
            dispatch(closeModal());
          }
        }
      })
    );
  };

  return (
    <Box display="flex" justifyContent="space-between">
      {!!url && (
        <Button
          className={classes.fix}
          onClick={() => navigateAlert()}
          variant="contained"
          color="primary"
        >
          Fix
        </Button>
      )}
      <Button
        variant="contained"
        color="primary"
        className={classes.remove}
        onClick={handleMarkDone}
      >
        Mark as Done
      </Button>
    </Box>
  );
};

export default TableAlertAction;
